"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainLinks = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const MainLink_1 = require("./MainLink");
const Styled = styled_components_1.default.section `
	&& {
		a {
			padding: 0;
			display: block;
		}
		.h3 {
			display: inline-block;
			margin: 16px 0 0 0;
		}
	}

	border-right: ${(p) => (p.borderRight ? `1px solid ${p.theme.palette.border}` : "unset")};
	border-bottom: ${(p) => (p.borderBottom ? `1px solid ${p.theme.palette.border}` : "unset")};

	&& {
		a {
			white-space: nowrap;
			display: block;
			&:hover {
				.arrow-wrap {
					transform: translate3d(0, 0, 0) translateX(1px) translateY(-1px);
				}
			}

			${(p) => p.theme.breakpoints.down("sm")} {
				white-space: normal;
			}
		}
	}
`;
const MainLinks = ({ links = [], borderRight = false, borderBottom = false, locale, disableHrefTemplate, }) => {
    return (react_1.default.createElement(Styled, { className: "main-links", borderRight: borderRight, borderBottom: borderBottom }, links.map((link) => {
        if (!link || (!link.key && !link.title))
            return;
        return (react_1.default.createElement(MainLink_1.MainLink, { key: link.key || link.title, link: link, locale: locale, disableHrefTemplate: disableHrefTemplate }));
    })));
};
exports.MainLinks = MainLinks;
//# sourceMappingURL=MainLinks.js.map